var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container oiline-shop-order" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.mainOrderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "mainOrderNo", $$v)
                      },
                      expression: "searchInfo.mainOrderNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "mobile", $$v)
                      },
                      expression: "searchInfo.mobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "spu编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNo", $$v)
                      },
                      expression: "searchInfo.spuNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "物流单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.logisticsBillNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "logisticsBillNo", $$v)
                      },
                      expression: "searchInfo.logisticsBillNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "物流状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchInfo.logisticsStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "logisticsStatus", $$v)
                        },
                        expression: "searchInfo.logisticsStatus"
                      }
                    },
                    _vm._l(_vm.logisticsStatusOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "自提状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchInfo.exchangeStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "exchangeStatus", $$v)
                        },
                        expression: "searchInfo.exchangeStatus"
                      }
                    },
                    _vm._l(_vm.exchangeStatusOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchInfo.payStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "payStatus", $$v)
                        },
                        expression: "searchInfo.payStatus"
                      }
                    },
                    _vm._l(_vm.payStatusOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "交易时间：" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "开始时间",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.dateStart,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "dateStart", $$v)
                      },
                      expression: "searchInfo.dateStart"
                    }
                  }),
                  _vm._v(" - "),
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "结束时间",
                      clearable: ""
                    },
                    model: {
                      value: _vm.searchInfo.dateEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "dateEnd", $$v)
                      },
                      expression: "searchInfo.dateEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSearch } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            "tooltip-effect": "dark",
            height: "calc(100vh - 28rem)",
            "row-key": _vm.getRowKey,
            "expand-row-keys": _vm.expandRowKeys
          },
          on: { "row-click": _vm.onRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { label: "", align: "right", type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "div",
                      { staticClass: "table-expand-item bairun-padding" },
                      [
                        _c(
                          "table",
                          {
                            staticClass: "order-detail",
                            attrs: {
                              cellspacing: "0",
                              cellpadding: "0",
                              border: "0"
                            }
                          },
                          [
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("购买商品：")
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "td-text",
                                  attrs: { colspan: "5" }
                                },
                                _vm._l(props.row.orderDetail.list, function(
                                  goodsItem
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "goods-item" },
                                    [
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "goods-logo" },
                                          [
                                            _c("el-image", {
                                              attrs: {
                                                src: goodsItem.imgUrl,
                                                fit: "contain"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "table-goods-info" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bairun-table-goods-name"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(goodsItem.goodsName)
                                                )
                                              ]
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(goodsItem.titleSub) +
                                                  "/" +
                                                  _vm._s(goodsItem.size)
                                              )
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                "购买数量：" +
                                                  _vm._s(goodsItem.goodsNum)
                                              )
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "goods-price" },
                                              [
                                                _vm._v(
                                                  "实付：¥" +
                                                    _vm._s(goodsItem.tradePay)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("订单号：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v(_vm._s(props.row.mainOrderNo))
                              ]),
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("交易时间：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(props.row.CreatedAt)
                                  )
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("手机号：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v(_vm._s(props.row.mobile))
                              ]),
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("订单金额：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v("¥" + _vm._s(props.row.orderSaleAmount))
                              ])
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("优惠金额：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v("¥" + _vm._s(props.row.orderDiscount))
                              ]),
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("实付金额：")
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "td-text",
                                  staticStyle: { "font-weight": "bold" }
                                },
                                [_vm._v("¥" + _vm._s(props.row.tradePay))]
                              )
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("退款金额：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                props.row.payStatus == 99
                                  ? _c("span", [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(props.row.orderPay) +
                                          _vm._s(
                                            props.row.refundType == 1
                                              ? "【退款不退货】"
                                              : props.row.refundType == 2
                                              ? "【退款退货】"
                                              : ""
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("订单备注：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v(_vm._s(props.row.remark))
                              ])
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("提货方式：")
                              ]),
                              _c("td", { staticClass: "td-text" }, [
                                _vm._v(
                                  _vm._s(
                                    props.row.logisticsType == 1
                                      ? "门店自提"
                                      : "包邮"
                                  )
                                )
                              ]),
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("订单状态：")
                              ]),
                              _c(
                                "td",
                                { staticClass: "td-text" },
                                [
                                  props.row.payStatus == 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "info",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getPayStatusName")(
                                                props.row.payStatus
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  props.row.payStatus == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getPayStatusName")(
                                                props.row.payStatus
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  props.row.payStatus == 2
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getPayStatusName")(
                                                props.row.payStatus
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  props.row.payStatus == 3
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "info",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getPayStatusName")(
                                                props.row.payStatus
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  props.row.payStatus == 99
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getPayStatusName")(
                                                props.row.payStatus
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            props.row.logisticsType == 1
                              ? _c("tr", [
                                  _c("td", { staticClass: "td-title" }, [
                                    _vm._v("自提门店：")
                                  ]),
                                  _c("td", { staticClass: "td-text" }, [
                                    _vm._v(
                                      _vm._s(props.row.logisticsSellerName)
                                    )
                                  ]),
                                  _c("td", { staticClass: "td-title" }, [
                                    _vm._v("自提状态：")
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "td-text" },
                                    [
                                      props.row.exchangeStatus == 1
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                size: "mini",
                                                effect: "plain"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f(
                                                    "getExchangeStatusName"
                                                  )(props.row.exchangeStatus)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      props.row.exchangeStatus == 2
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "waring",
                                                size: "mini",
                                                effect: "plain"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f(
                                                    "getExchangeStatusName"
                                                  )(props.row.exchangeStatus)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      props.row.exchangeStatus == 3
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                                effect: "plain"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f(
                                                    "getExchangeStatusName"
                                                  )(props.row.exchangeStatus)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            props.row.logisticsType == 1
                              ? _c("tr", [
                                  _c("td", { staticClass: "td-title" }, [
                                    _vm._v("自提码：")
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "td-text",
                                      attrs: { colspan: "3" }
                                    },
                                    [_vm._v(_vm._s(props.row.exchangeCode))]
                                  )
                                ])
                              : _vm._e(),
                            props.row.logisticsType == 2
                              ? _c("tr", [
                                  _c("td", { staticClass: "td-title" }, [
                                    _vm._v("收件人：")
                                  ]),
                                  _c("td", { staticClass: "td-text" }, [
                                    _c("div", [
                                      _vm._v(_vm._s(props.row.addressPerson))
                                    ]),
                                    _c("div", [
                                      _vm._v(_vm._s(props.row.addressMobile))
                                    ]),
                                    _c("div", [
                                      _vm._v(_vm._s(props.row.addressDetail))
                                    ])
                                  ]),
                                  _c("td", { staticClass: "td-title" }, [
                                    _vm._v("物流状态：")
                                  ]),
                                  _c("td", { staticClass: "td-text" }, [
                                    _c(
                                      "div",
                                      { staticClass: "bairun-margin-t" },
                                      [
                                        _c(
                                          "el-timeline",
                                          [
                                            _vm._l(
                                              props.row.logisticsTimeLine,
                                              function(item, index) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.onViewBill(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-timeline-item",
                                                        {
                                                          key: index,
                                                          class: {
                                                            active:
                                                              item.billNo != ""
                                                          },
                                                          attrs: {
                                                            icon: item.icon,
                                                            type: item.type,
                                                            color: item.color,
                                                            size: "large"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.content
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _c("tr", [
                              _c("td", { staticClass: "td-title" }, [
                                _vm._v("返券详情：")
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "td-text",
                                  attrs: { colspan: "5" }
                                },
                                _vm._l(
                                  props.row.orderDetail.ticketsList,
                                  function(ticketItem) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "ticket-item",
                                        class: {
                                          "has-use":
                                            ticketItem.ticketStatus == 1
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.onViewTicket(ticketItem)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "ticket-type" },
                                            [
                                              ticketItem.ruleType == 2
                                                ? _c("span", [_vm._v("油券/")])
                                                : _vm._e(),
                                              ticketItem.ruleType == 3
                                                ? _c("span", [
                                                    _vm._v("商品券/")
                                                  ])
                                                : _vm._e(),
                                              ticketItem.ticketType == 1
                                                ? _c("span", [_vm._v("满减")])
                                                : _vm._e(),
                                              ticketItem.ticketType == 2
                                                ? _c("span", [_vm._v("折扣")])
                                                : _vm._e(),
                                              ticketItem.ticketType == 3
                                                ? _c("span", [_vm._v("现金")])
                                                : _vm._e(),
                                              ticketItem.ticketType == 4
                                                ? _c("span", [_vm._v("单升")])
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ticket-name" },
                                            [
                                              _vm._v(
                                                _vm._s(ticketItem.ticketName)
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "bairun-rotate-tag" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  ticketItem.ticketStatus == 0
                                                    ? "未使用"
                                                    : "已使用"
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "订单号", prop: "mainOrderNo", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "用户信息", prop: "mobile", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "订单信息", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("金额：¥" + _vm._s(scope.row.orderSaleAmount))
                    ]),
                    _c("div", [
                      _vm._v("优惠：¥" + _vm._s(scope.row.orderDiscount))
                    ]),
                    _c("div", { staticClass: "goods-price" }, [
                      _vm._v("实付：¥" + _vm._s(scope.row.tradePay))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "提货方式", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.logisticsType == 1 ? "门店自提" : "包邮"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动信息", prop: "activityInfos" }
          }),
          _c("el-table-column", {
            attrs: { label: "物流/自提状态", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.logisticsType == 1
                      ? _c(
                          "div",
                          [
                            scope.row.exchangeStatus == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "info",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getExchangeStatusName")(
                                          scope.row.exchangeStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.exchangeStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "waring",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getExchangeStatusName")(
                                          scope.row.exchangeStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.exchangeStatus == 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getExchangeStatusName")(
                                          scope.row.exchangeStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.logisticsType == 2
                      ? _c(
                          "div",
                          [
                            scope.row.logisticsStatus == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "info",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 10
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 11
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 12
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.logisticsStatus == 20
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "success",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getLogisticsStatusName")(
                                          scope.row.logisticsStatus
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "订单状态", prop: "payStatus", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.payStatus == 0
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayStatusName")(scope.row.payStatus)
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    scope.row.payStatus == 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayStatusName")(scope.row.payStatus)
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    scope.row.payStatus == 2
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayStatusName")(scope.row.payStatus)
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    scope.row.payStatus == 3
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayStatusName")(scope.row.payStatus)
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    scope.row.payStatus == 99
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayStatusName")(scope.row.payStatus)
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "交易时间", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate2")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    [0, 1].includes(scope.row.payStatus) &&
                    scope.row.exchangeStatus != 3 &&
                    scope.row.logisticsType == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return function() {
                                  _vm.logisticsSellerUpdateVisible = true
                                  _vm.onUpdate(scope.row)
                                }.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("自提门店")]
                        )
                      : _vm._e(),
                    [1, 2].includes(scope.row.payStatus) &&
                    scope.row.logisticsType == 2 &&
                    scope.row.logisticsStatus < 3
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return function() {
                                  _vm.logisticsUpdateVisible = true
                                  _vm.onUpdate(scope.row)
                                }.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("快递发货")]
                        )
                      : _vm._e(),
                    scope.row.payStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "warning" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return function() {
                                  _vm.refundUpdateVisible = true
                                  _vm.onUpdate(scope.row)
                                }.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("售后处理")]
                        )
                      : _vm._e(),
                    _c(
                      "el-dropdown",
                      {
                        staticClass: "bairun-margin-l",
                        attrs: { trigger: "click" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return function() {}.apply(null, arguments)
                          },
                          command: _vm.handleCommand
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small" }
                          },
                          [
                            _vm._v("更多"),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right"
                            })
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            scope.row.logisticsStatus == 2
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      icon: "el-icon-truck",
                                      command: {
                                        action: "logisticsOk",
                                        row: scope.row
                                      }
                                    }
                                  },
                                  [_vm._v("确认收货")]
                                )
                              : _vm._e(),
                            scope.row.payStatus > 0
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      icon: "el-icon-edit",
                                      command: {
                                        action: "updateRemark",
                                        row: scope.row
                                      }
                                    }
                                  },
                                  [_vm._v("备注")]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  icon: "el-icon-delete",
                                  command: { action: "delete", row: scope.row }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.logisticsUpdateVisible,
            title: "快递发货设置"
          },
          on: {
            "update:visible": function($event) {
              _vm.logisticsUpdateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "快递公司:" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.formData.logisticsSupplierName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "logisticsSupplierName",
                                    $$v
                                  )
                                },
                                expression: "formData.logisticsSupplierName"
                              }
                            },
                            _vm._l(_vm.logisticSupplierOptions, function(item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "快递单号:" }
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.logisticsBillNo,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "logisticsBillNo", $$v)
                              },
                              expression: "formData.logisticsBillNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterLogisticsDialog }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.logisticsSellerUpdateVisible,
            title: "自提门店变更"
          },
          on: {
            "update:visible": function($event) {
              _vm.logisticsSellerUpdateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "自提门店:" }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.logisticsSellerId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "logisticsSellerId",
                                    $$v
                                  )
                                },
                                expression: "formData.logisticsSellerId"
                              }
                            },
                            _vm._l(_vm.sellerOptions, function(item) {
                              return _c(
                                "el-radio",
                                {
                                  key: item.sellerId,
                                  attrs: { label: item.sellerId }
                                },
                                [_vm._v(_vm._s(item.sellerName))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterLogisticsSellerDialog }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.refundUpdateVisible,
            title: "售后处理"
          },
          on: {
            "update:visible": function($event) {
              _vm.refundUpdateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.formData, "label-position": "right" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "处理结果:" }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.refundStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "refundStatus", $$v)
                                },
                                expression: "formData.refundStatus"
                              }
                            },
                            [
                              _c("el-radio", { key: 2, attrs: { label: 2 } }, [
                                _vm._v("通过")
                              ]),
                              _c("el-radio", { key: 3, attrs: { label: 3 } }, [
                                _vm._v("不通过")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.formData.logisticsType == 2
                ? [
                    _vm.formData.refundStatus == 2
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "bairun-required",
                                    attrs: { label: "退款方式:" }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.formData.refundType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "refundType",
                                              $$v
                                            )
                                          },
                                          expression: "formData.refundType"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { key: 2, attrs: { label: 2 } },
                                          [_vm._v("退款并退货")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { key: 1, attrs: { label: 1 } },
                                          [_vm._v("仅退款，不退货")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.refundStatus == 2 &&
                    _vm.formData.refundType == 2
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退货快递公司:" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value:
                                            _vm.formData
                                              .refundLogisticsSupplierName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "refundLogisticsSupplierName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.refundLogisticsSupplierName"
                                        }
                                      },
                                      _vm._l(
                                        _vm.logisticSupplierOptions,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item,
                                            attrs: { label: item, value: item }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.refundStatus == 2 &&
                    _vm.formData.refundType == 2
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退货快递号:" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入"
                                      },
                                      model: {
                                        value:
                                          _vm.formData.refundLogisticsBillNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "refundLogisticsBillNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.refundLogisticsBillNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "处理结果说明:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              clearable: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _vm.formData.refundStatus == 3 || _vm.formData.logisticsType == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.enterRefundDialog(2)
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.formData.refundStatus == 2 && _vm.formData.refundType == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.enterRefundDialog(2)
                        }
                      }
                    },
                    [_vm._v("确认退款")]
                  )
                : _vm._e(),
              _vm.formData.refundStatus == 2 && _vm.formData.refundType == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.enterRefundDialog(1)
                        }
                      }
                    },
                    [_vm._v("保 存")]
                  )
                : _vm._e(),
              _vm.formData.refundStatus == 2 && _vm.formData.refundType == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.enterRefundDialog(2)
                        }
                      }
                    },
                    [_vm._v("已收到货物，马上退款")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.remarkUpdateVisible,
            title: "订单备注"
          },
          on: {
            "update:visible": function($event) {
              _vm.remarkUpdateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.formData, "label-position": "right" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "处理结果说明:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              clearable: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterRemarkDialog }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }